import * as HeaderNavigationMobileStyled from 'components/Layouts/Headers/HeaderComponents/HeaderNavigationMobile/HeaderNavigationMobile.styled';
import { useState } from 'react';
import * as UserDropdownStyles from 'components/Layouts/Headers/HeaderComponents/UserDropdown/UserDropdown.styled';
import { CloseOutlineIc, HelpCircleOutlineIc } from '@dsch/dd-icons';
import { theme } from 'helpers/Theme';
import { USER_MENU } from 'components/Layouts/components/UserMenu';
import {
  UserDropdownItem,
  UserDropdownProps,
} from 'components/Layouts/Headers/HeaderComponents/UserDropdown/UserDropdown.typed';
import { getMenuItems } from 'components/Layouts/Headers/HeaderComponents/UserDropdown/UserDropdown.helper';

const UserDropdown = (props: UserDropdownProps) => {
  const { onClose, selected, user, messages, historyChecks } = props;

  const [showMore, setShowMore] = useState(true);

  const menuItems: UserDropdownItem[] = getMenuItems(
    selected,
    historyChecks,
    messages,
    !showMore,
  );

  menuItems.push({
    id: USER_MENU.HELP,
    selected: selected === USER_MENU.HELP,
    displayName: 'Help',
    link: `https://hello.donedeal.ie/hc/en-us/`,
    newTab: true,
    icon: <HelpCircleOutlineIc color={theme.colors.GREY_DARKER} />,
    divider: true,
    itemHidden: showMore,
  });

  if (user && user.isUserLogged) {
    return (
      <>
        <UserDropdownStyles.SubList>
          <UserDropdownStyles.ItemTitleWrapper>
            <UserDropdownStyles.ItemTitle>
              <span>{user.name}</span>
              <UserDropdownStyles.ItemTitleButton
                onClick={() => user.onUserLogOut()}
                data-tracking="header-nav"
              >
                Log out
              </UserDropdownStyles.ItemTitleButton>
            </UserDropdownStyles.ItemTitle>
            <UserDropdownStyles.Close
              onClick={onClose}
              data-testid="modal-close"
            >
              <CloseOutlineIc width="16" height="16" />
            </UserDropdownStyles.Close>
          </UserDropdownStyles.ItemTitleWrapper>

          {menuItems &&
            menuItems.map((item, index) => {
              return (
                <UserDropdownStyles.Item
                  key={index}
                  itemHidden={item.itemHidden}
                >
                  <UserDropdownStyles.LinkWrapper>
                    <UserDropdownStyles.Link
                      href={item.link}
                      data-tracking="header-nav"
                    >
                      {item.icon && item.icon && (
                        <UserDropdownStyles.IconItem>
                          {item.icon}
                        </UserDropdownStyles.IconItem>
                      )}
                      <UserDropdownStyles.ItemLabel>
                        {item.displayName}
                      </UserDropdownStyles.ItemLabel>
                    </UserDropdownStyles.Link>
                    {item.notifications && (
                      <UserDropdownStyles.Badge count={item.notifications} />
                    )}
                  </UserDropdownStyles.LinkWrapper>
                </UserDropdownStyles.Item>
              );
            })}

          <UserDropdownStyles.ItemToggle onClick={() => setShowMore(!showMore)}>
            {showMore ? 'See more' : 'See less'}
          </UserDropdownStyles.ItemToggle>
        </UserDropdownStyles.SubList>
        <HeaderNavigationMobileStyled.Separator />
      </>
    );
  } else {
    return (
      <>
        <UserDropdownStyles.ItemTitleWrapper>
          <UserDropdownStyles.ItemTitle>
            <span>Browse DoneDeal</span>
            <UserDropdownStyles.ItemTitleButton
              onClick={() => user?.onUserLogIn()}
              data-tracking="header-nav"
            >
              Sign up or Log in
            </UserDropdownStyles.ItemTitleButton>
          </UserDropdownStyles.ItemTitle>
          <UserDropdownStyles.Close onClick={onClose} data-testid="modal-close">
            <CloseOutlineIc width="16" height="16" />
          </UserDropdownStyles.Close>
        </UserDropdownStyles.ItemTitleWrapper>

        <HeaderNavigationMobileStyled.Separator />
      </>
    );
  }
};

export { UserDropdown };
